import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LanguageProvider } from "@/lib/i18n";
import Index from "./pages/Index.tsx";
import DlaKliniki from "./pages/DlaKliniki.tsx";
import DlaPracownikow from "./pages/DlaPracownikow.tsx";
import JakToDziala from "./pages/JakToDziala.tsx";
import Kontakt from "./pages/Kontakt.tsx";
import Login from "./pages/Login.tsx";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/en" element={<Index />} />
            <Route path="/cz" element={<Index />} />
            <Route path="/dla-kliniki" element={<DlaKliniki />} />
            <Route path="/en/for-clinics" element={<DlaKliniki />} />
            <Route path="/cz/pro-kliniky" element={<DlaKliniki />} />
            <Route path="/dla-pracownikow" element={<DlaPracownikow />} />
            <Route path="/en/for-staff" element={<DlaPracownikow />} />
            <Route path="/cz/pro-zamestnance" element={<DlaPracownikow />} />
            <Route path="/jak-to-dziala" element={<JakToDziala />} />
            <Route path="/en/how-it-works" element={<JakToDziala />} />
            <Route path="/cz/jak-to-funguje" element={<JakToDziala />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/en/contact" element={<Kontakt />} />
            <Route path="/cz/kontakt" element={<Kontakt />} />
            <Route path="/login" element={<Login />} />
            <Route path="/en/login" element={<Login />} />
            <Route path="/cz/prihlaseni" element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
